import instance from './testing.instance';

export const getUserBotList = () => instance.get(`/notifications/telegram/bots/`);

export const addUserBotList = () => instance.post(`/notifications/telegram/identifier/`);

export const removeUserBotList = () => instance.post(`/notifications/telegram/unlink/`)

